class SamplePackValidation extends HTMLElement {
  constructor() {
    super();
    this.form = document.getElementById(this.getAttribute('form'));
    this.setupEventListeners();
  }

  setupEventListeners() {
    if (!this.form) return;
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    if (this.getAttribute('template') !== 'sample-pack') return;
    
    event.preventDefault();
    
    try {
      // Check current cart
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Get the current product variant ID
      const formData = new FormData(this.form);
      const currentVariantId = formData.get('id');
      
      // Check if this sample pack is already in cart
      const samplePackInCart = cart.items.some(item => 
        item.variant_id === Number(currentVariantId)
      );
      
      if (samplePackInCart) {
        alert('You can only have one sample pack in your cart.');
        return;
      }
      
      // Check if user has previously purchased this product
      const orderHistory = await this.checkOrderHistory();
      if (orderHistory.hasPurchased) {
        alert('This sample pack can only be purchased once per customer.');
        return;
      }
      
      // If all validations pass, submit the form
      this.form.submit();
      
    } catch (error) {
      console.error('Error during sample pack validation:', error);
    }
  }

  async checkOrderHistory() {
    try {
      const response = await fetch('/apps/customer-order-history/check', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          productId: this.getAttribute('product-id')
        })
      });
      return await response.json();
    } catch (error) {
      console.error('Error checking order history:', error);
      return { hasPurchased: false };
    }
  }
}

customElements.define('sample-pack-validation', SamplePackValidation);